import React from 'react';
import { MapPin, Briefcase, Calendar } from 'lucide-react';

/**
 * Компонент секции региональных настроек
 */
const RegionalSettingsSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  russianRegions
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <MapPin className="w-5 h-5 mr-2 text-cyan-500" />
        Региональные настройки
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Учет рабочих дней */}
        <div className="col-span-full mb-1">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeWorkingDays"
              checked={formData.includeWorkingDays || formData.unit === 'workingDays'}
              onChange={handleInputChange}
              disabled={formData.unit === 'workingDays'}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
              <Briefcase className="w-4 h-4 text-cyan-500 mr-1" />
              Учитывать только рабочие дни (пн-пт)
            </span>
          </label>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400 ml-6">
            При этом расчет будет производиться без учета выходных (суббота и воскресенье)
          </p>
        </div>

        {/* Учет праздников */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeHolidays"
              checked={formData.includeHolidays}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
              <Calendar className="w-4 h-4 text-cyan-500 mr-1" />
              Учитывать праздничные дни
            </span>
          </label>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400 ml-6">
            Будут учтены государственные праздники и перенесенные выходные дни
          </p>
        </div>

        {/* Выбор региона (если включены праздники) */}
        {formData.includeHolidays && (
          <div className="col-span-full mt-2">
            <label htmlFor="region" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Регион России
            </label>
            <select
              id="region"
              name="region"
              value={formData.region}
              onChange={handleInputChange}
              className="form-select w-full"
            >
              {russianRegions.map((region) => (
                <option key={region.id} value={region.id}>
                  {region.name}
                </option>
              ))}
            </select>
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
              Выберите регион для учета дополнительных региональных праздников
            </p>
          </div>
        )}
      </div>

      {/* Информационный блок */}
      {(formData.includeWorkingDays || formData.unit === 'workingDays' || formData.includeHolidays) && (
        <div className="mt-4 bg-cyan-50 dark:bg-cyan-900/20 p-3 rounded-lg border border-cyan-100 dark:border-cyan-800">
          <p className="text-sm text-cyan-700 dark:text-cyan-300">
            <span className="font-medium">Важно: </span>
            {formData.includeWorkingDays || formData.unit === 'workingDays' 
              ? 'Расчет будет произведен только по рабочим дням (пн-пт)' 
              : ''
            }
            {(formData.includeWorkingDays || formData.unit === 'workingDays') && formData.includeHolidays 
              ? ', ' 
              : ''
            }
            {formData.includeHolidays 
              ? `учитывая праздничные дни для региона "${russianRegions.find(r => r.id === formData.region)?.name || 'Россия'}"` 
              : ''
            }
          </p>
        </div>
      )}
    </div>
  );
};

export default RegionalSettingsSection;